export enum ColorMode {
  RGB,
  HEX,
  RGBA,
  DECIMAL,
}
